import { render, staticRenderFns } from "./HomeActivities.vue?vue&type=template&id=4d8f83e4&scoped=true&"
import script from "./HomeActivities.vue?vue&type=script&lang=js&"
export * from "./HomeActivities.vue?vue&type=script&lang=js&"
import style0 from "./HomeActivities.vue?vue&type=style&index=0&id=4d8f83e4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f83e4",
  null
  
)

export default component.exports